import React from 'react';
import Stack from '@mui/material/Stack';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslate } from '@im/react-localization';

interface QuantityValidationDialogProps {
  error?: {
    max?: boolean;
    min?: boolean;
  };
  onClose: () => void;
}

export default function QuantityValidationDialog({
  error,
  onClose,
}: Readonly<QuantityValidationDialogProps>) {
  const translate = useTranslate();

  return (
    <Dialog onClose={onClose} open={!!error}>
      <DialogTitle sx={{ fontSize: '18px', lineHeight: '28px' }}>
        <Stack alignItems="center" flexDirection="row" spacing={3}>
          <ErrorOutlineRoundedIcon />
          {translate('VendorDeals.QuantityInvalid')}
        </Stack>
        <IconButton
          data-testid="gds-vp-ed-dialog-close-icon"
          onClick={onClose}
          sx={{
            '.MuiSvgIcon-root': {
              height: '22px',
              width: '22px',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {error?.max && translate('VendorDeals.QuantityNotGreaterThan', error)}
        {error?.min && translate('VendorDeals.QuantityNotLesserThan', error)}
      </DialogContent>
    </Dialog>
  );
}
